'use strict';
import { orderBy } from "lodash";
import { Injectable } from "ng-metadata/core";
import { MappingTablesCache } from "../../../mappingTablesCache/mappingTablesCache.service";

@Injectable()
export class ShareService {

    private shareIconsToDisplay: string[] = ['WhatsApp', 'Facebook', 'Twitter', 'LinkedIn'];
    private _requiredIconsList: string[] = [];

    constructor(private mappingTablesCache: MappingTablesCache) {
        this.setRequiredIconsList();
    }

    private setRequiredIconsList() {
        let shareIconsListUnfiltered = orderBy(this.mappingTablesCache.getTable('Share Action Configuration'), (val) => parseInt(val['source1']), 'asc');
        shareIconsListUnfiltered = shareIconsListUnfiltered.map((config) => config.target);
        this._requiredIconsList = shareIconsListUnfiltered.filter((serviceName) => (this.shareIconsToDisplay.indexOf(serviceName) !== -1));
    }

    get requiredIconsList() {
        return this._requiredIconsList;
    }

    public shareServices = [
        {
            key: 'Facebook',
            value: 'https://www.facebook.com/sharer/sharer.php?u=URL_PLACEHOLDER'
        },
        {
            key: 'Twitter',
            value: 'https://twitter.com/intent/tweet?url=URL_PLACEHOLDER'
        },
        {
            key: 'LinkedIn',
            value: 'https://www.linkedin.com/sharing/share-offsite/?url=URL_PLACEHOLDER'
        },
        {
            key: 'WhatsApp',
            value:'https://api.whatsapp.com/send?text=URL_PLACEHOLDER'
        }
    ]

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/shareAction/share.service.ts